import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getScanSchedule, scheduleScan } from "../../actions/customer";
import { useSelector } from "react-redux";

// Custom styles for scan scheduling
const labelClassStyle = {
    margin: "0 15px 0 0",
    display: "inline-flex",
    alignItems: "center"
};

const radioButtonStyle = {
    marginRight: "5px"
};

const TPRMSetting = () => {
    const dispatch = useDispatch();
    const id = useSelector(state => {
        return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    });

    // Get scan schedule data from Redux store
    const scanScheduleReduxData = useSelector(state => state?.customer?.scanSchedule?.data);

    const [scanScheduleData, setScanScheduleData] = useState(null);
    const [scanScheduleLoading, setScanScheduleLoading] = useState(false);
    const [scanFrequency, setScanFrequency] = useState({
        attackSurface: "daily",
        darkWeb: "daily"
    });
    const [attackSurfaceScan, setAttackSurfaceScan] = useState(true);
    const [darkWebScan, setDarkWebScan] = useState(true);

    // Add effect to fetch scan schedule
    useEffect(() => {
        if (id) {
            getScanSchedule(id, dispatch);
        }
    }, [id]);

    useEffect(() => {
        setScanScheduleData(scanScheduleReduxData);
        setScanScheduleLoading(false);

        if (scanScheduleReduxData) {
            setAttackSurfaceScan(scanScheduleReduxData.attackSurface !== "no");
            setDarkWebScan(scanScheduleReduxData.dataExposure !== "no");
            
            setScanFrequency({
                attackSurface: scanScheduleReduxData.attackSurface === "no" ? "daily" : scanScheduleReduxData.attackSurface,
                darkWeb: scanScheduleReduxData.dataExposure === "no" ? "daily" : scanScheduleReduxData.dataExposure
            });
        }
    }, [scanScheduleReduxData]);

    // Handle scan frequency change
    const handleScanFrequencyChange = (scanType, frequency) => {
        setScanFrequency({
            ...scanFrequency,
            [scanType]: frequency
        });
    };

    // Submit scan schedule
    const submitScanSchedule = () => {
        setScanScheduleLoading(true);
        let scheduleData = {
            attackSurface: attackSurfaceScan ? scanFrequency.attackSurface : "no",
            dataExposure: darkWebScan ? scanFrequency.darkWeb : "no",
        };

        scheduleScan(id, scheduleData, dispatch)
            .then(() => {
                setScanScheduleLoading(false);
            })
            .catch(() => {
                setScanScheduleLoading(false);
            });
    };

    return (
        <div className="container-fluid risk-dashboard">
            <div className="block-header">
                <div className="row">
                    <div className="col-md-6 col-sm-12">
                        <h1 className="welcome-text mb-3">TPRM Settings</h1>
                    </div>
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                {scanScheduleLoading ? (
                                    <div className="text-center p-4">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                        <p className="mt-3">Loading scan schedule data...</p>
                                    </div>
                                ) : (
                                    <div className="row clearfix">
                                        <div className="col-lg-12 col-md-12">
                                            <h5 className="mb-3">Configure Scan Schedule</h5>
                                            <div className="form-group" style={{
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                alignItems: "baseline"
                                            }}>
                                                <label style={{ marginRight: "10px", minWidth: "120px", fontWeight: "bold" }}>
                                                    Attack Surface
                                                </label>
                                                <label style={labelClassStyle}>
                                                    <input
                                                        checked={!attackSurfaceScan}
                                                        onChange={() => setAttackSurfaceScan(false)}
                                                        style={radioButtonStyle}
                                                        type="radio"
                                                        name="attackSurface"
                                                        value="no"
                                                    />
                                                    No Scan
                                                </label>

                                                <label style={labelClassStyle}>
                                                    <input
                                                        checked={attackSurfaceScan && scanFrequency.attackSurface === "daily"}
                                                        onChange={() => {
                                                            setAttackSurfaceScan(true);
                                                            handleScanFrequencyChange("attackSurface", "daily");
                                                        }}
                                                        style={radioButtonStyle}
                                                        type="radio"
                                                        name="attackSurface"
                                                        value="daily"
                                                    />
                                                    Daily
                                                </label>
                                                <label style={labelClassStyle}>
                                                    <input
                                                        checked={attackSurfaceScan && scanFrequency.attackSurface === "weekly"}
                                                        onChange={() => {
                                                            setAttackSurfaceScan(true);
                                                            handleScanFrequencyChange("attackSurface", "weekly");
                                                        }}
                                                        style={radioButtonStyle}
                                                        type="radio"
                                                        name="attackSurface"
                                                        value="weekly"
                                                    />
                                                    Weekly
                                                </label>
                                                <label style={labelClassStyle}>
                                                    <input
                                                        checked={attackSurfaceScan && scanFrequency.attackSurface === "monthly"}
                                                        onChange={() => {
                                                            setAttackSurfaceScan(true);
                                                            handleScanFrequencyChange("attackSurface", "monthly");
                                                        }}
                                                        style={radioButtonStyle}
                                                        type="radio"
                                                        name="attackSurface"
                                                        value="monthly"
                                                    />
                                                    Monthly
                                                </label>
                                            </div>

                                            <div className="form-group mb-0" style={{
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                alignItems: "baseline"
                                            }}>
                                                <label style={{ marginRight: "10px", minWidth: "120px", fontWeight: "bold" }}>
                                                    Dark Web
                                                </label>
                                                <label style={labelClassStyle}>
                                                    <input
                                                        checked={!darkWebScan}
                                                        onChange={() => setDarkWebScan(false)}
                                                        style={radioButtonStyle}
                                                        type="radio"
                                                        name="darkWeb"
                                                        value="no"
                                                    />
                                                    No Scan
                                                </label>

                                                <label style={labelClassStyle}>
                                                    <input
                                                        checked={darkWebScan && scanFrequency.darkWeb === "daily"}
                                                        onChange={() => {
                                                            setDarkWebScan(true);
                                                            handleScanFrequencyChange("darkWeb", "daily");
                                                        }}
                                                        style={radioButtonStyle}
                                                        type="radio"
                                                        name="darkWeb"
                                                        value="daily"
                                                    />
                                                    Daily
                                                </label>
                                                <label style={labelClassStyle}>
                                                    <input
                                                        checked={darkWebScan && scanFrequency.darkWeb === "weekly"}
                                                        onChange={() => {
                                                            setDarkWebScan(true);
                                                            handleScanFrequencyChange("darkWeb", "weekly");
                                                        }}
                                                        style={radioButtonStyle}
                                                        type="radio"
                                                        name="darkWeb"
                                                        value="weekly"
                                                    />
                                                    Weekly
                                                </label>
                                                <label style={labelClassStyle}>
                                                    <input
                                                        checked={darkWebScan && scanFrequency.darkWeb === "monthly"}
                                                        onChange={() => {
                                                            setDarkWebScan(true);
                                                            handleScanFrequencyChange("darkWeb", "monthly");
                                                        }}
                                                        style={radioButtonStyle}
                                                        type="radio"
                                                        name="darkWeb"
                                                        value="monthly"
                                                    />
                                                    Monthly
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 mt-4">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={submitScanSchedule}
                                                disabled={scanScheduleLoading}
                                            >
                                                {scanScheduleLoading ? 'Saving...' : 'Save Settings'}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TPRMSetting;
